import { render } from "./ImageZoomOverlay.vue?vue&type=template&id=b3599d60&scoped=true"
import script from "./ImageZoomOverlay.vue?vue&type=script&lang=js"
export * from "./ImageZoomOverlay.vue?vue&type=script&lang=js"

import "./ImageZoomOverlay.vue?vue&type=style&index=0&id=b3599d60&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3599d60"]])

export default __exports__